module.exports = __webpack_public_path__ + "img/app-tcby-menu-25.d01c52f4.webp";